'use strict';

/**
 * inline decorator implementation for the video-teaser module.
 *
 * @author Jan Widmer <jan.widmer@namics.com>
 */
T.Module.VideoTeaser.Inline = T.createDecorator({

	_stateClasses: {
		videoOpen: 'state-video-open',
		videoInitialized: 'state-video-initialized'
	},

	_eventNames: {
		loadYoutubeApi: 'pageController.loadYoutubeApi'
	},

	start: function start(resolve) {
		this.$ctx = $(this._ctx);
		this.neededCookieCategory = 'C0004';

		$.extend(this._selectors, {
			videoTeaser: function videoTeaser(id) {
				return '.m-video-teaser[data-t-id="' + id + '"]';
			},
			videoIframe: '[data-js-m-video-teaser-iframe]',
			animatedElement: '[data-js-m-video-teaser__video-wrapper]'
		});

		$.extend(this._stateClasses, {
			videoOpen: 'state-video-open',
			videoInitialized: 'state-video-initialized'
		});

		$.extend(this._eventNames, {
			loadYoutubeApi: 'pageController.loadYoutubeApi'
		});

		this.$videoIframe = this.$ctx.find(this._selectors.videoIframe);
		this.$animatedElement = this.$ctx.find(this._selectors.animatedElement);

		this.youtubeApiLoaded = false;
		this.animationDone = false;
		this.autoplay = this.$ctx.data('autoplay');

		this._parent.start(resolve);
	},


	/**
  * Initializing the component
  *
  * Please note: this method overrides a parent method
  *
  * @returns {void}
  */
	initializeComponent: function initializeComponent() {
		this.$videoIframe.attr('id', 'video-' + this.$ctx.data('t-name'));

		// Set src only if video cookie is accepted
		if (this.checkCookieCategory()) {
			this.$videoIframe.attr('src', this.$videoIframe.data('src'));
		}

		this.$videoLink.one('click', this.onVideoLinkClick.bind(this));

		this._events.emit(this._eventNames.loadYoutubeApi, {
			callbackFn: this.onYoutubeApiLoaded.bind(this)
		});
	},


	// Check if video cookie is set
	checkCookieCategory: function checkCookieCategory() {
		if (window.Optanon) {
			var allowedCookies = window.OptanonActiveGroups || '';
			var allowedCookiesArray = allowedCookies.split(',');

			return allowedCookiesArray.indexOf(this.neededCookieCategory) >= 0;
		}
	},


	/**
  * Initializing the youtube player after loading the youtube api
  *
  * @returns {void}
  */
	initializeYoutubePlayer: function initializeYoutubePlayer() {
		this.youtubePlayer = new YT.Player(this.$videoIframe.attr('id'), {
			events: {
				'onReady': this.onPlayerReady.bind(this)
			}
		});
	},


	/**
  * Event when the youtube player is ready
  *
  * @returns {void}
  */
	onPlayerReady: function onPlayerReady() {
		this.$ctx.addClass(this._stateClasses.videoInitialized);
		this.youtubePlayer.playVideo();
	},


	/**
  * Event when the user clicked on the video play button
  *
  * @param {Event} ev The click event
  * @returns {void}
  */
	onVideoLinkClick: function onVideoLinkClick(ev) {
		var _this = this;

		ev.preventDefault();

		this.$animatedElement.one('transitionend', function () {
			_this.animationDone = true;

			if (_this.youtubeApiLoaded) {
				_this.$ctx.addClass(_this._stateClasses.videoInitialized);
				_this.initializeYoutubePlayer();
			}
		});

		this.$ctx.addClass(this._stateClasses.videoOpen);
	},


	/**
  * Event when the youtube api loaded
  *
  * @returns {void}
  */
	onYoutubeApiLoaded: function onYoutubeApiLoaded() {
		this.youtubeApiLoaded = true;

		if (this.animationDone) {
			this.initializeYoutubePlayer();
		}

		if (this.autoplay) {
			this.initVideoWhenInView();
		}
	},


	/**
  * Trigger video playback as soon as it's in viewport.
   *
  * @returns {void}
  **/
	initVideoWhenInView: function initVideoWhenInView() {
		var _this2 = this;

		var terrificId = this._ctx.getAttribute('data-t-id');

		window.inView(this._selectors.videoTeaser(terrificId)).once('enter', function () {
			return _this2.$videoLink.trigger('click');
		});
	}
});